import React from 'react';
export function ScatteredSection() {
  return <section className="bg-white py-6 sm:py-9" data-id="element-163" data-mp="3gt7whwmtho6h">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-164" data-mp="3vdjhd4mf211h">
        <div className="border-l-4 border-diag bg-mist p-4 sm:p-6" data-id="element-165" data-mp="3vb6s06ebwoee">
          <h2 className="text-[20px] leading-[1.08] text-navy sm:text-[30px]" data-id="element-166" data-mp="d0ldwnqf0q2k">
            😩 Stop searching through different references for every engine fault
          </h2>
          <p className="mt-2.5 text-[14px] font-medium leading-snug text-steel sm:text-[17px]" data-id="element-167" data-mp="mwewoouq9fss">
            You already know how to work on gasoline engines. The problem is wasting
            time jumping between manuals, videos, diagrams and disconnected
            information just to determine what to test next. Open the system, choose
            the symptom or system and follow the organized diagnostic references.{' '}
            <strong className="font-bold text-navy" data-id="element-168" data-mp="2xprhu3zvynqq">
              Less searching. More structured troubleshooting.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}